<template>
  <div v-if="loaded">
    <div v-if="currentPipelineReview.custom_field_values.length == 0">
      <label class="mt-4 block text-sm leading-5 font-medium text-gray-700">
        How is the agent and how is their week going so far? Is there anything we can do to help the agent on a personal
        level?
      </label>
      <div
        class="user-generated-content shadow-sm bg-gray-200 border p-8 text-sm mt-1 border-gray-300 rounded-md"
        v-html="sanitize(currentPipelineReview.intro_question)"
      ></div>

      <label class="mt-4 block text-sm leading-5 font-medium text-gray-700">
        Who are the agent's top 3 customers, and what could the agent be doing differently to get each of them into
        escrow?
      </label>
      <div
        class="user-generated-content shadow-sm bg-gray-200 border p-8 text-sm mt-1 border-gray-300 rounded-md"
        v-html="sanitize(currentPipelineReview.top_three_prospects)"
      ></div>

      <label class="mt-4 block text-sm leading-5 font-medium text-gray-700">
        What is the agent not getting from us that would help them do their job at the highest possible level?
      </label>
      <div
        class="user-generated-content shadow-sm bg-gray-200 border p-8 text-sm mt-1 border-gray-300 rounded-md"
        v-html="sanitize(currentPipelineReview.team_leader_suggestions)"
      ></div>
    </div>

    <div v-for="customField in customFieldsForEntity" :key="customField.id" class="sm:col-span-1 mt-4">
      <div v-if="currentPipelineReview.custom_field_values.find(f => f.custom_field_id === customField.id)">
        <dt class="text-sm leading-5 font-medium text-gray-500">
          {{ customField.name }}
        </dt>
        <dd class="mt-1 text-sm leading-5 text-gray-900">
          <ValueViewerAndEditor
            :customField="customField"
            :customFieldValue="
              currentPipelineReview.custom_field_values.find(f => f.custom_field_id === customField.id)
            "
            customFieldableType="PipelineReview"
            :customFieldableId="parseInt($route.params.id)"
            :method="'view'"
          />
        </dd>
      </div>
    </div>

    <hr class="my-8 -ml-8 -mr-8" />

    <header class="font-bold">Private</header>
    <p class="text-sm text-gray-500 mb-8">This is not visible to the agent.</p>

    <label class="mt-4 block text-sm leading-5 font-medium text-gray-700">
      Your Private Notes (not visible to teammate)
    </label>
    <div
      class="user-generated-content shadow-sm bg-gray-200 border p-8 text-sm mt-1 border-gray-300 rounded-md"
      v-html="sanitize(currentPipelineReview.team_leader_private_notes)"
    ></div>

    <label class="mt-4 block text-sm leading-5 font-medium text-gray-700 mb-1">Pipeline Performance</label>
    <PipelinePerformance :score="currentPipelineReview.score" :disabled="true" />
  </div>
</template>

<script>
import TeammatePipelineReviewAttachments from '../team/TeammatePipelineReviewAttachments.vue';
import Card from '../Card/index.vue';
import PipelinePerformance from '../PipelinePerformance/index.vue';
import { sanitizeRichText } from '../../utilities/sanitization';
import ValueViewerAndEditor from '../custom_fields/ValueViewerAndEditor.vue';

export default {
  components: {
    PipelinePerformance,
    TeammatePipelineReviewAttachments,
    ValueViewerAndEditor,
  },
  data() {
    return {
      loaded: false,
      customFieldsForEntity: [],
      currentPipelineReview: null,
      eventRecording: null,
      selectedRecordingTab: 'Score',
    };
  },
  props: {
    pipelineReview: {
      type: Object,
      required: true,
    },
    teammate: {
      type: Object,
      required: true,
    },
  },
  async mounted() {
    await this.fetchCustomFieldsForEntity();
    await this.hydratePipelineReview();

    this.loaded = true;
  },
  methods: {
    async fetchCustomFieldsForEntity() {
      const res = await fetch(`/api/contacts/${this.teammate.id}/pipeline_reviews/custom_fields_for_entity`);
      const data = await res.json();
      this.customFieldsForEntity = data.custom_fields_for_entity;
    },
    sanitize(html) {
      return sanitizeRichText(html);
    },
    handleSelectedRecordingTab(tab) {
      this.selectedRecordingTab = tab;
    },
    async hydratePipelineReview() {
      const res = await fetch(`/api/contacts/${this.teammate.id}/pipeline_reviews/${this.pipelineReview.id}`);
      const { record } = await res.json();
      this.currentPipelineReview = record;
    },
  },
};
</script>
